/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Logger } from '@app/core/logger.service';

const log = new Logger('ApiTokenInterceptor');

/**
 * Add access token to request
 */
@Injectable()
export class ApiTokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthenticationService) {
    log.debug('init');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /**
     * Add access token to request
     */
    if (this.auth.isAuthenticated()) {
      request = request.clone({
        setHeaders: {
          Authorization: this.auth.accessToken.token_type + ' ' + this.auth.accessToken.access_token,
        },
      });
    }

    return next.handle(request);
  }
}
